module.exports = __webpack_public_path__ + "static/img/13.01e1139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/13.jpg
// module id = tZ6w
// module chunks = 1